import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import { ASSETS_BY_IDS_QUERY } from 'personalization-lib/api/queries/assetQueries';
const useFetchAssetsByIds = (source, ids = [], onError) => {
  const sortedIds = useMemo(() => [...ids].sort(), [ids]);
  const {
    data,
    loading,
    error
  } = useQuery(ASSETS_BY_IDS_QUERY, {
    variables: {
      source: source,
      ids: sortedIds
    },
    skip: !source || !sortedIds.length,
    onError
  });
  return useMemo(() => ({
    assetsById: data === null || data === void 0 ? void 0 : data.assetsById,
    loading,
    error
  }), [data === null || data === void 0 ? void 0 : data.assetsById, loading, error]);
};
export default useFetchAssetsByIds;